// extracted by mini-css-extract-plugin
export default {"search":"FilterMenuSearchBar_search__JOWkU"};